
import { AmmunitionStockEvent } from './ammunition-stock-event.model';
import { ComposedRowsTypeInfo, CrudTypeInfo, RowsEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AmmunitionStockEventRowsTypeInfoBase<G> extends ComposedRowsTypeInfo<AmmunitionStockEvent, number, G> {
  constructor(itemTypeInfo: CrudTypeInfo<AmmunitionStockEvent, number>, rowsEntityDecorator: RowsEntityDecorator<AmmunitionStockEvent, number, G>) {
    super(itemTypeInfo, rowsEntityDecorator);
  }
}



